import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, Input } from '@angular/core';
import { Platform, ActionSheetController, ModalController, NavController  } from '@ionic/angular';
//import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { SplashScreen } from '@capacitor/splash-screen';
//import { StatusBar } from '@ionic-native/status-bar/ngx';
import { StatusBar, Style } from '@capacitor/status-bar';
import { AuthService } from './auth/services/auth.service';
import { GuardsCheckEnd, GuardsCheckStart, NavigationCancel, NavigationError, NavigationStart, Router, RoutesRecognized } from '@angular/router';
import { Storage } from '@ionic/storage';
import { AccountService, IApiAccount } from './account/services/account.service';
import { ProfileService } from './account/services/profile.service';
import { HttpHelpers } from './shared/helpers/http.helpers';
import { LoaderService } from './shared/services/loader.service';
import { SettingService } from './shared/services/setting.service';
import { PageService } from './services/page.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { StoreService, IStore, IStoreMenuCategoryItem } from './store/services/store.service';
import { ActivatedRoute } from '@angular/router';
import { ItemBrandServiceService } from './store/services/item-brand-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd } from '@angular/router';
import { AlertService } from './shared/services/alert.service';
import { ItemService } from './store/services/item.service';
//import { Url } from 'url';
import { map } from 'rxjs/operators';
import { CouponHelpers } from './shared/helpers/coupon.helpers';
import { CouponService } from './shared/services/coupon.service';
import { ModalDisplayComponent } from './shared/components/modal-display/modal-display.component';
import { ReservationConfigurationService } from './shared/services/reservation-configuration.service';
import { NotificationServiceService } from './store/services/notification-service.service';
import { ListPageComponent } from './store/pages/list-page/list-page.component';
import { OrderListPageComponent } from './account/pages/order-list-page/order-list-page.component';
import { PayRewardPageComponent } from './account/pages/pay-reward-page/pay-reward-page.component';
import { ProfilePageComponent } from './account/pages/profile-page/profile-page.component';
import { SupportHomePageComponent } from './support/pages/support-home-page/support-home-page.component';
import { ReservationComponent } from './reservation-page/pages/reservation-page/reservation-page.component';
import { LocationsPageComponent } from './pages/locations-page/locations-page.component';
import { OfferPageComponent } from './account/pages/offer-page/offer-page.component';
import { AuthenticationPageComponent } from 'src/app/auth/pages/authentication-page/authentication-page.component';
import { StoreListModalComponent } from './store/modals/store-list-modal/store-list-modal.component';

import { MenuService } from './store/services/menu.service';
import { GoogleTagManagerService } from './shared/services/google-tag-manager.service';
import { AnalyticsService } from './shared/services/analytics.service';
//ADD THE IMPORT FOR COOKIE CONSENT POP UP
import { CookieConsentModalComponent } from './shared/modals/cookie-consent-modal/cookie-consent-modal.component';
import { CookieConsentPopupComponent } from './shared/modals/cookie-consent-modal/cookie-consent-popup.component';
import { MenuController } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { TranslationService } from './shared/services/translation.service';
import { LanguageRequestModalsComponent } from './shared/modals/language-request-modals/language-request-modals.component';
import { PushNotifications, Token, PushNotificationSchema, ActionPerformed } from '@capacitor/push-notifications';
import { Device } from '@capacitor/device';
import { Geolocation } from '@capacitor/geolocation';
import { GeolocationService, IGeolocationRequest } from './shared/services/geolocation.service';
import { LocalNotifications } from '@capacitor/local-notifications';
import { ApiControllerService } from './shared/services/api-controller.service';
import { AnnouncementsComponent } from './pages/announcements/announcements.component';
import { IBaseBlogsRequest, IBaseNewsRequest, IBlogs, INews, NewsBlogsService } from './shared/services/news-blogs.service';


const CACHE_KEY='cartStorage';
export interface INavigationItem {
  title: string;
  url: string;
  icon: string;
  component?: any;
  notification?: any;
  show?: (component: AppComponent) => boolean;
}

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  cookieConsentGiven = false;
  showMiniCookiePopup: boolean = false;
  screenWidth: number = window.innerWidth;
  

  primary: IApiAccount;
  public selectedIndex = 0;
  private addition = true;
  ipAddress: any;
  @ViewChild('toggleMenu',{read: ElementRef}) toggleMenu: ElementRef;
  @ViewChild('menuIcon',{read: ElementRef}) menuIcon: ElementRef;
  public disablePanel = true;
  public reservationAvailable: boolean = false;
  public showTableNavigation: boolean = false;

  geoRequest: IGeolocationRequest; 

  private itemOBj: IStoreMenuCategoryItem = {
    itemId: '',
    item: null,
    subItems: null,
  }
 
  public appPreviewPages : INavigationItem[] = [
    {
      title: 'Nav.Stores',
      url: '/stores',
      icon: 'restaurant'
    }
  ]
  public appDefaultPages : INavigationItem[] = [];
  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
 

  public appPages : INavigationItem[] = this.appDefaultPages;
  showCookiePopup: boolean = true;

  get isTenant() {
    if (environment.deviceApp)
      return true;

    return (HttpHelpers.getSubdomain());
  }

  get name() {
    return this.setting?.name;
  }

  get logo() {
    if (environment.deviceApp)
      return '/assets/logo.png';

    return this.setting.logo;
  }

  get icon() {
    if (environment.deviceApp)
      return '/assets/logo.png';

    
    if (!this.setting.icon)
      return this.logo;
       
    return this.setting.icon;
  }

  get facebook() {
    return this.setting.facebook;
  }

  get instagram() {
    return this.setting.instagram;
  }

  get twitter() {
    return this.setting.twitter;
  }

  get supportedLanguages() {
    if (this.setting.configuration) {
      return this.setting.configuration.supportedLanguages;
    }   
  }

  get routeUrl(){
    return this.router.url;
  }

  blogsCategories: IBlogs[] = [];
  newsCategories: INews[] = [];

  newsRequest: IBaseNewsRequest;
  blogsRequest: IBaseBlogsRequest;
  
  languageExist: boolean = false;
  constructor(private http: HttpClient,
    private modalCtrl: ModalController,
    private route: ActivatedRoute,
    private itemBrandService: ItemBrandServiceService,
    private sanitizer: DomSanitizer,
    private platform: Platform,
    //private splashScreen: SplashScreen,
    //private statusBar: StatusBar,
    //private translate: TranslateService,
    public auth: AuthService,
    private router: Router,
    private actionSheetController: ActionSheetController,
    private storage: Storage,
    public setting: SettingService,
    public accountService: AccountService,
    private storeService: StoreService,
    private cdr: ChangeDetectorRef,
    private loader: LoaderService,
    private couponService: CouponService,
    private alertService: AlertService,
    private reservationConfigurationService: ReservationConfigurationService,
    public NotificationService: NotificationServiceService,
    private navCtrl: NavController,
    private itemService: ItemService,
    private menuService: MenuService,
    private gtmService: GoogleTagManagerService,
    private analytics: AnalyticsService,
    private translationService: TranslationService,
    private geolocationService: GeolocationService,
    private apiController: ApiControllerService,
    private newsBlogService: NewsBlogsService,
 ) {
  // use this to trouble shoot routes issues
  /*
  this.router.events.subscribe(event => {
    const time = new Date().toISOString();

    if (event instanceof NavigationStart) {
      console.log(`[${time}] NavigationStart -> url:`, event.url);
    } else if (event instanceof RoutesRecognized) {
      console.log(`[${time}] RoutesRecognized -> url:`, event.url, 'snapshot:', event.state.root);
    } else if (event instanceof GuardsCheckStart) {
      console.log(`[${time}] GuardsCheckStart -> url:`, event.url);
    } else if (event instanceof GuardsCheckEnd) {
      console.log(`[${time}] GuardsCheckEnd -> url:`, event.url, 'canActivate:', event.shouldActivate);
    } else if (event instanceof NavigationEnd) {
      console.log(`[${time}] NavigationEnd -> url:`, event.urlAfterRedirects);
    } else if (event instanceof NavigationCancel) {
      console.log(`[${time}] NavigationCancel -> url:`, event.url, 'reason:', event.reason);
    } else if (event instanceof NavigationError) {
      console.error(`[${time}] NavigationError -> url:`, event.url, 'error:', event.error);
    }
  });
  */

    // do we actually need this? it's in the app module
    this.initializeApp();

    this.sanitizer = sanitizer;

    // due to some changes you need to follow a more linear process
    this.appDefaultPages = [
      {
        title: 'Nav.Home',
        url: '/home',
        icon: 'home'
      },
      {
        title: 'Nav.Announcements',
        url: '/announcements',
        icon: 'calendar',
        component: AnnouncementsComponent,
        show: (component) => component.setting.configuration.navBarConfiguration?.enableAnnouncements
      },
      {
        title: 'Nav.Stores',
        url: '/stores',
        icon: 'restaurant',
        component: StoreListModalComponent
      },
      {
        title: 'Nav.PlaceTableOrder',
        url: '/stores/table-order',
        icon: 'fast-food',
        component: StoreListModalComponent,
        show: (component) => component.showTableNavigation
      },
      {
        title: 'Nav.Reservation',
        url: '/reservation',
        icon: 'calendar',
        component: ReservationComponent,
        //show: (component) => component.setting.configuration.showReservation
        show: (component) => component.reservationAvailable
      },
      {
        title: 'Nav.MyOrders',
        url: '/account/my-orders',
        icon: 'newspaper',
        component: OrderListPageComponent,
        show: (component) => component.auth.isAuthenticated
      },
      {
        title: this.setting.configuration ? (this.setting.configuration.storeCount > 1 ?  'Nav.Locations' : 'Nav.Location') : 'Nav.Locations',
        url: '/locations',
        icon: 'compass',
        component: LocationsPageComponent
      },
      {
        title: 'Nav.Account',
        url: '/account',
        icon: 'card',
        show: (component) => !component.setting.configuration.hideMemberProgram
      },
      {
        title: 'Nav.Pay&Reward',
        url: '/account/pay-rewards',
        icon: 'star-half',
        component: PayRewardPageComponent,
        show: (component) => !component.setting.configuration.hideMemberProgram
      },    
      {
        title: 'Nav.Offers',
        url: '/account/offers',
        icon: 'pricetags',
        component: OfferPageComponent,
        notification: this.getAvailableCoupons(),
        show: (component) => !component.setting.configuration.hideMemberProgram || !component.setting.configuration.hideECouponProgram
      },
      // {
      //   title: 'Nav.MyFavorites',
      //   url: '/myfavorites',
      //   icon: 'heart',
      //   show: (component) => !component.setting.configuration.hideMemberProgram
      // },
      /*{
        title: 'Nav.Reservation',
        url: '/reservation',
        icon: 'calendar'
      },
      
      {
        title: 'Nav.Friends',
        url: '/chat',
        icon: 'people'
      },*/
      {
        title: 'Nav.Profile',
        url: '/account/profile',
        icon: 'person-circle',
        component: ProfilePageComponent,
        show: (component) => !component.setting.configuration.hideMemberProgram
      },
      {
        title: 'Nav.Support',
        url: '/support',
        icon: 'mail-open',
        component: SupportHomePageComponent,
      }
      /*,
      {
        title: 'Profile',
        url: '/profile',
        icon: 'person-circle'
      },
      {
        title: 'Login test',
        url: '/auth',
        icon: 'person-circle'
      },
      {
        title: 'Sign out',
        url: '',
        icon: 'log-out'
      }*/
    ];



    // temporary fix for the "supported language. set a default language first before proceeding to changing it"
    this.setDefaultLanguage('fr');
    this.validateSupportedLanguage();

    router.events.subscribe((e) => {
      let currentRoute = this.route.root;
   
      while (currentRoute.children[0] !== undefined) {
        currentRoute = currentRoute.children[0];
        if (e instanceof NavigationEnd) {
         
          if(currentRoute.snapshot.params.language)
          {
            
            if(currentRoute.snapshot.params.language == 'en' || currentRoute.snapshot.params.language == 'fr')
            {
              this.languageExist = true;
              //translate.use(currentRoute.snapshot.params.language);
              this.translationService.setLanguage(currentRoute.snapshot.params.language);
              localStorage['lang'] = currentRoute.snapshot.params.language;
            }
          }
        }
      }

    });
    

    this.getAllBlogs();
    this.getAllNews();
  }

  validateSupportedLanguage() {
    let languages = this.supportedLanguages;

    
    if (!languages) {
      // use mobile's default language?
      this.setDefaultLanguage('fr');
      return;
    }

    if (languages.length != 0) {
      languages.forEach(lang => {
        if (lang.isFavorite) {
          this.setDefaultLanguage(lang.name.toLowerCase());
          return;
        }
      })
    } else {

      // use mobile's default language?
      this.setDefaultLanguage('fr');
    }
  }

  setDefaultLanguage(lang: string) {
    /*
    this.translate.setDefaultLang(lang);
    this.translate.currentLang = lang;
    */
    this.translationService.setLanguage(lang);
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      this.clearCache();
      //this.statusBar.styleDefault();
      //await StatusBar.setStyle({ style: Style.Default });
      //await SplashScreen.hide();

      if (Capacitor.isNativePlatform()) {
        await StatusBar.setStyle({ style: Style.Default });
      }
      await SplashScreen.hide();
     
    });
  }
  
  ngAfterContentChecked() {
    this.disablePanel = this.setting.disablePanel;
    this.cdr.detectChanges();
  }

  async checkCookieConsent() {
    const existingConsent = localStorage.getItem('cookieConsent');
    if (existingConsent) {
      //console.log('Consent already set:', existingConsent);
      this.cookieConsentGiven = true;
      this.showCookiePopup = false;
      return;
    }

    //console.log('Showing cookie modal');

    /*
    const modal = await this.modalCtrl.create({
      component: CookieConsentModalComponent,
      cssClass: 'cookie-modal-class',
      componentProps: {
        language: this.translate.currentLang  // Pass current language
      }
    });
    */

    /*
    await modal.present();

    const { data, role } = await modal.onDidDismiss();
    if (role === 'minimize') {
      this.showCookiePopup = true; // Show the mini-popup when user clicks X
    }
      
    if (data) {
      localStorage.setItem('cookieConsent', data);
      console.log('User cookie choice:', data);
      this.cookieConsentGiven = true;
      this.showCookiePopup = false;
    }
      */
  }


// async openConsentModal() {
//   const modal = await this.modalCtrl.create({
//     component: CookieConsentModalComponent,
//     cssClass: 'cookie-consent-modal',
//     backdropDismiss: false,
//   });

//   await modal.present();

//   const { data } = await modal.onWillDismiss();

//   if (data && data.choiceMade === false) {
//     this.openMiniPopup(); // ✅ REOPEN mini popup if no choice made
//   }
// }


  async openMiniPopup() {
    const modal = await this.modalCtrl.create({
      component: CookieConsentPopupComponent,
      cssClass: 'cookie-consent-popup',
      backdropDismiss: false,
    });
    await modal.present();
  }

  ngOnInit() {
    //////////////////////////////////////////////////////////////////////////////////////
    // this is only used for mobile. however it'S inconsistent. i'll think of an alternative to see what we can do with this. used to try and detect one UI on some phones and move the html content from it - mathieu
    const userAgent = navigator.userAgent || navigator.vendor;
    const isMobileOrTablet = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

    if (!(/iPad|iPhone|iPod/.test(userAgent))) {
      //ensures it's not an apple device
      const styles = getComputedStyle(document.documentElement);

      const safeAreaTop = styles.getPropertyValue('--ion-safe-area-top');
      const safeAreaBottom = styles.getPropertyValue('--ion-safe-area-bottom');

      document.documentElement.classList.add('android-safe-area');

      //console.log('Top safe area:', safeAreaTop);
      //console.log('Bottom safe area:', safeAreaBottom);
    }
    
    //////////////////////////////////////////////////////////////////////////////////////

    this.gtmService.init();
    this.screenWidth = window.innerWidth;

    //this is going to be for the push-notification. if it's on a device, it'll trigger the push notification permissions
    if (environment.deviceApp) {
      //this.initPush();
    }
    //console.log("test");
    //new Notification('Hello', { body: 'This is a simulated notification' });

    window.addEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
    })

    // disable for mobile
    // i'll comment it temporarily to just remove it
    /*
    if(!isMobileOrTablet) {
      const consentStatus = localStorage.getItem('cookieConsentGiven');

      // Ensure it's a strict boolean comparison
      this.cookieConsentGiven = consentStatus === 'true';

      // Only show the mini popup if consent has not been given
      if (!this.cookieConsentGiven) {
        this.showMiniCookiePopup = true;
      } else {
        this.showMiniCookiePopup = false;
      }
    }
    */
    

    //  Add or remove body class based on nav position
    if (this.setting.navigationSetting) {
      document.body.classList.add('nav-left');
    } else {
      document.body.classList.remove('nav-left');
    }

    // this tracks a specific param in the URL
    const urlParams = new URLSearchParams(window.location.search);
    var Ref = urlParams.get('Ref');
    var biid = urlParams.get('BIID');  
    var lang = urlParams.get('Lang');  
    var Referrer = urlParams.get('Referrer');  

    if(Ref) {
      this.setting.setReferenceCode = Ref;
    }

    if (lang) {
      localStorage['lang'] = lang;
      //this.translate.use(lang.toLowerCase());
      this.translationService.setLanguage(lang);
    }

    // specifically for homers, it collect's the saved name at startup.
    const startup_langSelection = localStorage.getItem('startup_language');
    if(startup_langSelection) {
      localStorage.removeItem('startup_language');
      localStorage['lang'] = startup_langSelection;
      this.translationService.setLanguage(startup_langSelection);
    }

    

    // this will capture URL with "referrer" param
    if(Referrer) {
      console.log(Referrer);
      this.analytics.setRefCode = Referrer;
    }
    
    //removed temporarily
    /*
    if(!isMobileOrTablet) {
      this.checkCookieConsent();
    }
    */
    
    /*
    if(this.showCookiePopup) {
      this.openFullConsentModal();
    }*/

    if (biid) {
      this.itemService.getSpecificMenuItem(biid, this.setting.getMerchantId()).subscribe(menuitem => {
        this.menuService.itemDetailDirect(menuitem);
      });
    }


    this.previewPageMode();

   
    /* this.http.get('https://api.ipify.org/?format=json').subscribe(ip => {
      this.ipAddress = ip;
      this.setting.ipAddress = this.ipAddress.ip;
    }); */

    this.apiController.get('https://api.ipify.org/?format=json').subscribe(ip => {
      this.ipAddress = ip;
      this.setting.ipAddress = this.ipAddress.ip;
    });

    if (this.setting) { 
      let merchantId = this.setting.getMerchantId();
      this.itemBrandService.getBrands(merchantId).subscribe(data => {
        this.itemBrandService.itemBrands = data;
      });

      if (this.setting.configuration?.customFont != null) {
        this.fontStyle();
      }  

      this.setting.disablePanel = true;

      if (this.setting.configuration) {
        // These two will tell either the store sells food or retail or both
        this.setting.foodItems = this.setting.configuration?.foodItems;
        this.setting.retailItems = this.setting.configuration?.retailItems;
        this.showTableNavigation = this.setting.configuration?.showTableNavigation && this.setting.configuration?.allowTable;
      }

      // Call getAvailableCoupons() twice a day
      var halfDay = 12 * 60 * 60 * 1000;
      setInterval(() => {
        this.getAvailableCoupons();
      }, halfDay);

      this.storeService.getStores().subscribe(stores => {
        stores.forEach(store => {
          this.reservationConfigurationService.findReservationConfiguration(store.id).subscribe(config => {
            if (config && config.useReservation) {
              this.reservationAvailable = true;
            }
          });
        });
      });
    }


    this.auth.logOut$.subscribe(() => {
      this.clearCache();
    });

    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }

    // Logic of deleting the cart
    let tracker = new Date();
    let ExpirationTime = tracker.getDate();

    if (ExpirationTime > localStorage['TimeLimit'] || (localStorage['TimeLimit'] >= 30 && ExpirationTime == 1)) {
      localStorage.removeItem(CACHE_KEY);
      localStorage.removeItem("TimeLimit");
      localStorage.removeItem("StoreId");
    }





    // to get the geolocation of the user (only accurate if not using a VPN!!)
    this.getLocation();

    // this pull the language off of the OS/browser language
    /* 
    const language = navigator.language; //|| navigator.userLanguage;
    console.log(language);
    */

    // this one pull the language of off of mobile devices using capacitor or the language on the navigator/browser
    //var language = this.getOSLanguage();


    if (localStorage.getItem('lang')) {
      let lang = localStorage.getItem('lang');
      //this.translate.use(lang.toLowerCase());
      this.translationService.setLanguage(lang);
    } else {
      // this is to have a popup requesting to select a language
      //this.LanguageRequestModals();

      this.getOSLanguage().then(language => {
        this.translationService.setLanguage(language);
      });
      //this.translationService.setLanguage(language);
      
    }

    // this still works if you want to immediately remove the initial loading (not recommended)
    //this.fullyLoaded();
    
    // this is an example on how it should be done. its best to use the loader progress bar. once set to 100+ it'll automatically remove it
    /*
    let numbertest = 0;
    setInterval(() => {
      numbertest = numbertest + 20;
      if(numbertest >= 100) {
        numbertest = 100;
      }
      (window as any).updateLoaderProgress(numbertest);
    }, 500);
    */
  }

  fullyLoaded() {
    // this will be used once the content of the page (including images) has been fully loaded
    (window as any).hideAppShell();
  }

  initPush() {
    // Request permission
    PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        PushNotifications.register();
      } else {
        console.error('Push permission not granted');
      }
    });

    // On registration success
    PushNotifications.addListener('registration', (token: Token) => {
      console.log('Push registration success, token:', token.value);
      // Send this token to your server to send notifications

      this.sendTestNotification();
    });

    // On registration error
    PushNotifications.addListener('registrationError', (error) => {
      console.error('Push registration error:', error);
    });

    // On receiving a notification
    PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
      console.log('Push received:', notification);
    });

    // On notification action performed (tap)
    PushNotifications.addListener('pushNotificationActionPerformed', (action: ActionPerformed) => {
      console.log('Push action performed:', action.notification);
    });
  }

  async sendTestNotification() {
    const perm = await LocalNotifications.requestPermissions();
    if (perm.display === 'granted') {
      await LocalNotifications.schedule({
        notifications: [
          {
            title: 'Test Push Notification',
            body: 'This simulates a push notification!',
            id: 1,
            schedule: { at: new Date(Date.now() + 30000) }, // 30 second later
            sound: null,
            smallIcon: 'splash',
            largeIcon: 'splash',
            attachments: [
              { id: 'logo', url: 'assets/icon/logo.png' } 
            ],
          },
        ],
      });
      console.log('Test notification scheduled');
    } else {
      console.error('Local notification permission not granted');
    }
  }


  async getLocation() {
    //const coordinates = await Geolocation.getCurrentPosition();

    //const lat = coordinates.coords.latitude;
    //const lng = coordinates.coords.longitude;

    //console.log(lat + " - " + lng);

    // this is limited. 1 request per second max give or take and they ask to cache the result. no bulk location and can't be used by large commercial apps
  
    //this.getGeolocation(lat, lng);


    /*
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
    );
    */

    // google is more comonly used but you need an API key to make it work
    /*
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyC-b2Q6rsoMQiYQJgDfgCNvNJrTAc-Xn30`
    );
    */
    
    /*
    const data = await response.json();

    console.log(data);

    console.log({
      //neighbourhood: data.address.neighbourhood,
      suburb: data.address.suburb,
      city: data.address.city,
      state: data.address.state,
      country: data.address.country,
      country_code: data.address.country_code
    });
    */
  }

  getGeolocation(lat: number, lon: number){
    this.fetchGeolocation(lat, lon).subscribe(async Geo => {
      console.log(Geo);
      
    });
  }

  fetchGeolocation(lat: number, lon: number) {
    this.geoRequest = {
      latitude: lat,
      longitude: lon
    }

    return this.geolocationService.getGeoData(this.geoRequest);
  }

  //i don't currently have capacitor/device so this doesn't inherently work
  async getOSLanguage(): Promise<string> {
    let language: string | undefined;
    let languageReturn: string;

    try {
      // Try to get the device language (Capacitor plugin)
      const info = await Device.getLanguageCode();
      language = info.value; // This will be something like 'en', 'fr', etc.
    } catch (e) {
      console.warn('Could not get device language:', e);
    }

    // Fallback for browser
    if (!language) {
      language = navigator.language || (navigator.languages && navigator.languages[0]) || 'en';

      if(language.includes("en")) {
        language = 'en';
      } else if(language.includes("fr")) {
        language = 'fr';
      } else {
        language = 'en';
      }
    }

    //localStorage.setItem('lang', language);
    if(!language) {
      language = 'en';
    } else {
      languageReturn = language;
    }
    return languageReturn;
  }


async LanguageRequestModals() {
   const modal = await this.modalCtrl.create({
    component: LanguageRequestModalsComponent,
    cssClass: 'startup-language-popup-model',
    componentProps: {
      //language: this.translationService.getLanguage()
    }
  });

  await modal.present();

  const { data, role } = await modal.onDidDismiss();
  /*
  if (role === 'close') {
    this.showCookiePopup = true;
  }
  */

  if (data) {
    /*
    localStorage.setItem('cookieConsent', data);
    console.log('User cookie choice:', data);
    this.cookieConsentGiven = true;
    this.showCookiePopup = false;
    */
  }
}

async openFullConsentModal() {
  const modal = await this.modalCtrl.create({
    component: CookieConsentModalComponent,
    cssClass: 'cookie-modal-class',
    componentProps: {
      //language: this.translate.currentLang  // Pass current language
      language: this.translationService.getLanguage()  // Pass current language
    }
  });

  await modal.present();

  const { data, role } = await modal.onDidDismiss();
  if (role === 'close') {
    this.showCookiePopup = true;
  }

  if (data) {
    localStorage.setItem('cookieConsent', data);
    console.log('User cookie choice:', data);
    this.cookieConsentGiven = true;
    this.showCookiePopup = false;
  }
}


onMiniConsentAccepted() {
  localStorage.setItem('cookieConsentGiven', 'true'); //  Consent saved
  this.cookieConsentGiven = true;
  this.showMiniCookiePopup = false;
}



async onMiniConsentCustomize() {
  // ✅ Show the mini popup and let the user expand categories inside it
  this.showMiniCookiePopup = true;
  this.cookieConsentGiven = false;


}

  IsPopup(pageDate) {

    try {
      if(pageDate.title == 'Nav.Stores' || pageDate.title == 'Nav.PlaceTableOrder') {
        if(pageDate.component && this.setting.configuration.uIoptions.storeToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Reservation') {
        if(pageDate.component && this.setting.configuration.uIoptions.reservationToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.MyOrders') {
        if(pageDate.component && this.setting.configuration.uIoptions.myOrdersToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Offers') {
        if(pageDate.component && this.setting.configuration.uIoptions.offersToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Location' || pageDate.title == 'Nav.Locations') {
        if(pageDate.component && this.setting.configuration.uIoptions.locationToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Pay&Reward') {
        if(pageDate.component && this.setting.configuration.uIoptions.rewardsToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Profile') {
        if(pageDate.component && this.setting.configuration.uIoptions.profileToPopup) {
          return true;
        }
      } else if(pageDate.title == 'Nav.Support') {
        if(pageDate.component && this.setting.configuration.uIoptions.contactUsToPopup) {
          return true;
        }
      } else if(pageDate == 'Nav.Login') {
        if(this.setting.configuration.uIoptions.loginToPopup) {
          return true;
        }
      }
    } catch (e) {

    }
    

    return false;
  }

  optionSelect(index) {
    if(this.setting.openNav) {
      this.setting.toggleShowMore();
    }
    
    this.selectedIndex = index;
  }

  async OpenLoginModal() {
    if(this.setting.openNav) {
      this.setting.toggleShowMore();
    }

    if(this.setting.configuration.uIoptions.loginToPopup) {
    
      // prevents crash if the undocked navbar is inside a popup
      const modal = await this.modalCtrl.create({
        component: AuthenticationPageComponent,
        cssClass: 'auth-popup-model',
        componentProps: {
          disableHeader: true
        }
      });
    
      modal.onWillDismiss()
        .then((result) => {
          
      });
    
      await modal.present();
    }
    
  }


  async ConfirmAndOpenModal(pageDate, index) {
    if(this.setting.openNav) {
      this.setting.toggleShowMore();
    }

    this.selectedIndex = index;


    if(pageDate.title == 'Nav.Stores') {
      if(pageDate.component && this.setting.configuration.uIoptions.storeToPopup) {
      
        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'store-popup-model',
          componentProps: {
            isTableOrder: false,
            disableHeader: true
          }
        });

        //navigate to the first store this merchant has so it can lay a menu in the background (only if it's not already on a menu)
        if (!this.router.url.includes('/stores/menu')) {
          this.storeService.getStores().subscribe((data: IStore[]) => {
            var stores = data;
  
            this.navCtrl.navigateRoot('/stores/menu/' + stores[0].id + '/pickup');
          });
        }
        

        /*
        modal.onWillDismiss()
          .then((result) => {
            
        });*/
      
        await modal.present();

        const { data } = await modal.onDidDismiss();

        if(data?.route){
          this.navCtrl.navigateRoot('/stores' + data.route);
          /*
          this.router.navigate(['/menu'], {
            queryParams: {
              storeId: data.route[1],
              orderType: data.route[2]
            }
          });
          */
        }
      }
    } else if (pageDate.title == 'Nav.PlaceTableOrder') {
      if(pageDate.component && this.setting.configuration.uIoptions.storeToPopup) {
      
        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'store-popup-model',
          componentProps: {
            isTableOrder: true,
            disableHeader: true
          }
        });

        //navigate to the first store this merchant has so it can lay a menu in the background (only if it's not already on a menu)
        if (!this.router.url.includes('/stores/menu')) {
          this.storeService.getStores().subscribe((data: IStore[]) => {
            var stores = data;
  
            this.navCtrl.navigateRoot(['/stores/menu/' + stores[0].id + '/pickup']);
          });
        }
      
        await modal.present();

        const { data } = await modal.onDidDismiss();

        if(data?.route){
          this.navCtrl.navigateRoot(['/stores' + data.route]);
        }
      }
    } else if(pageDate.title == 'Nav.Reservation') {
      if(pageDate.component && this.setting.configuration.uIoptions.reservationToPopup) {
      
        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'reservation-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.MyOrders') {
      if(pageDate.component && this.setting.configuration.uIoptions.myOrdersToPopup) {
      
        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'myorders-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.Offers') {
      if(pageDate.component && this.setting.configuration.uIoptions.offersToPopup) {
      
        if(!this.auth.isAuthenticated) {
          if(this.setting.configuration.uIoptions.loginToPopup) {
          
            // prevents crash if the undocked navbar is inside a popup
            const modal = await this.modalCtrl.create({
              component: AuthenticationPageComponent,
              cssClass: 'auth-popup-model',
              componentProps: {
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });
          
            await modal.present();
            return;
          } else {
            this.router.navigate(['auth']);
            return;
          }
        }

        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'offers-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.Location' || pageDate.title == 'Nav.Locations') {
      if(pageDate.component && this.setting.configuration.uIoptions.locationToPopup) {
      
        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'location-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.Pay&Reward') {
      if(pageDate.component && this.setting.configuration?.uIoptions?.rewardsToPopup) {
      
        if(!this.auth.isAuthenticated && !this.setting.configuration?.uIoptions?.extendedRewards) {
          if(this.setting.configuration.uIoptions.loginToPopup) {
          
            // prevents crash if the undocked navbar is inside a popup
            const modal = await this.modalCtrl.create({
              component: AuthenticationPageComponent,
              cssClass: 'auth-popup-model',
              componentProps: {
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });
          
            await modal.present();
            return;
          } else {
            this.router.navigate(['auth']);
            return;
          }
        }

        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'reward-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.Profile') {
      if(pageDate.component && this.setting.configuration.uIoptions.profileToPopup) {
      
        if(!this.auth.isAuthenticated) {
          if(this.setting.configuration.uIoptions.loginToPopup) {
          
            // prevents crash if the undocked navbar is inside a popup
            const modal = await this.modalCtrl.create({
              component: AuthenticationPageComponent,
              cssClass: 'auth-popup-model',
              componentProps: {
                disableHeader: true
              }
            });
          
            modal.onWillDismiss()
              .then((result) => {
                
            });
          
            await modal.present();
            return;
          } else {
            this.router.navigate(['auth']);
            return;
          }
        }

        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'profile-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    } else if(pageDate.title == 'Nav.Support') {
      if(pageDate.component && this.setting.configuration.uIoptions.contactUsToPopup) {
      
        const modal = await this.modalCtrl.create({
          component: pageDate.component,
          cssClass: 'support-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
    }

    
    
  }

  getAvailableCoupons() {
      // Make call to service
      let offers = [];
      let coupons = [];
      
      if(!this.setting.configuration) return;

      coupons = this.couponService.processCouponAvailability();

      // Get offers from service via getItems() method
      if(!this.setting.configuration.hideMemberProgram) {
        this.accountService.$primary
            .subscribe((primary) => {
              this.primary = primary;
              if(this.primary?.ApiAccountId) {
                this.accountService.getItems(this.primary.ApiAccountId, true)
                  .subscribe(
                    (data) => {
                      offers = data
                    }
                  )
              }
              
            })
      } 
      
      // Wait for response from service before setting notification and pop-up message
      setTimeout(() => {

        // If notification already set, load offers badge value from local storage
        if(localStorage.getItem('OffersAvailable') && localStorage.getItem('OffersAvailable') != undefined) {
          for(let i = 0; i < this.appPages.length; i++){
            if(this.appPages[i].title == 'Nav.Offers') this.appPages[i].notification = JSON.parse(localStorage.getItem('Offers Available'));
          }
        }
        for(let i = 0; i < this.appPages.length; i++){
          if(this.appPages[i].title == 'Nav.Offers'
          && JSON.parse(localStorage.getItem('Offers Available')) != coupons.length + offers.length){
            this.appPages[i].notification = coupons.length + offers.length;
            localStorage.setItem('OffersAvailable', JSON.stringify(coupons.length + offers.length));
          }
          if((coupons.length && offers.length) && !localStorage.getItem('OffersAvailable')) {
            localStorage.setItem('OffersAvailable', JSON.stringify(coupons.length + offers.length));
          }
          
        }
        
        let rightNow: any = new Date();
        let millisecondsPerDay = 1000 * 60 * 60 * 18;
        let messageFrequencyPerDay = parseInt(this.setting.configuration.offersNotificationMessageFrequency)
      
        /*
        if(messageFrequencyPerDay != 0 && 
          JSON.parse(localStorage.getItem('OffersAvailable')) > 0){    
          // For getting from account service
          // let messageLastShown = this.accountService.getLastOffersMessageDisplay(this.auth.memberId)
          let messageLastShown: any = new Date(JSON.parse(localStorage.getItem('offersMessageLastShown')));
          // Never seen before
          if(!messageLastShown) {
            this.displayNotificationPopUp(coupons.length, offers.length);
            localStorage.setItem('offersMessageLastShown', JSON.stringify(rightNow));
          }
          
      
          // Seen before, check if enough time has passed to display again
          if(rightNow - messageLastShown > millisecondsPerDay / messageFrequencyPerDay) {
            this.displayNotificationPopUp(coupons.length, offers.length);
            localStorage.setItem('offersMessageLastShown', JSON.stringify(rightNow));
          }
        }
        */

        // un comment to actively test the display
        //this.displayNotificationPopUp(coupons.length, offers.length);

      // update local storage
      localStorage.setItem('coupons', JSON.stringify(coupons));
 
    }, 5000);

    // check local storage every 5 seconds to check for change in number of coupons, update number if changed.
    setInterval(() => {
      let numberOfCoupons = JSON.parse(localStorage.getItem('coupons')).length;
      for(let i = 0; i < this.appPages.length; i++){
        if(this.appPages[i].title == 'Nav.Offers' && numberOfCoupons != this.appPages[i].notification ) {
          this.appPages[i].notification = numberOfCoupons + offers.length;
          localStorage.setItem('OffersAvailable', JSON.stringify(coupons.length + offers.length))
        }
      }
    }, 5000)
    
  }


  displayNotificationPopUp(coupons, offers) {
    //quick note, ionic 6 is unfortunately not working well with innerhtml. as such i made a new component for it for the time being. it's not pretty but it does the job
    
        this.alertService.showAlert(
          'test-alert', 
          '',
          '',
          /*
          `<p">${coupons + offers} ${this.translate.instant("Coupon.CouponsAvailable")}</p>
          <ion-button href="account/offers">${this.translate.instant("Coupon.ClickHere")}</ion-button>`,
          */
         /*
          `
            <p>${coupons + offers} ${this.translate.instant("Coupon.CouponsAvailable")}</p>
            <a href="account/offers">${this.translate.instant("Coupon.ClickHere")}</a>
          `,
          */
          `
            <p>${coupons + offers} ${this.translationService.translate("Coupon.CouponsAvailable")}</p>
            <a href="account/offers">${this.translationService.translate("Coupon.ClickHere")}</a>
          `,
          
            [
              {
                //text: `${this.translate.instant('Checkout.Close')}`,
                text: this.translationService.translate('Checkout.Close'),
                role: 'cancel',
                cssClass: 'alert-button',
                id: 'cancel-button',
              }
            ],
    
        );
    
  }

  fontStyle()
  {
    let fontName = this.setting.configuration.customFont.name;
    let fontUrl = this.setting.configuration.customFont.link;
    let link=document.createElement('link');
    let style = document.createElement('style');
    style.innerText = "@font-face { font-family: " + fontName + " } body {--ion-font-family:  " + fontName + " !important;font-family:  " + fontName + " !important}"
    link.href=fontUrl;
    link.rel="stylesheet"
    document.getElementsByTagName('head')[0].appendChild(style);
    document.getElementsByTagName('head')[0].appendChild(link)
  }



  async logout() {
    const actionSheet = await this.actionSheetController.create({
      header: this.translationService.translate('Auth.LogoutConfirmation'),
      buttons: [{
        text: this.translationService.translate('General.Yes'),
        handler: () => {
          // when the use logs out
          this.analytics.conversionUpdate("logOut");

          this.auth.logout();
          this.router.navigateByUrl('');

          //gotta clear the linkCoupon in case another account log in and try to link some promotion.
          localStorage.removeItem('linkCoupon');
        }
      },
      {
        text: this.translationService.translate('General.No'),
        role: 'cancel'
      }]
    });

    actionSheet.present();
  }
  onClick(e: any)
  {
    this.selectedIndex = e;
  }
  changeLang(lang: string) {

    localStorage['lang'] = lang;
    //this.translate.use(lang.toLowerCase());
    this.translationService.setLanguage(lang.toLowerCase());
  }

  clearCache() {
    this.storage.remove(AccountService.primaryStorageKey);
    this.storage.remove(ProfileService.profileStorageKey);
    this.storage.remove(SettingService.configurationStorageKey);
    this.storage.remove(PageService.homeImagesStorageKey);
  } 

    toggle()  
    { 
     if(!this.storeService.toggleNav)//To make it unclickable
       {
        this.setting.navToggle = !this.setting.navToggle; //to adjust property of refine nav
        let toggleIcon = this.toggleMenu.nativeElement;
        toggleIcon.classList.toggle('toggle');
        this.menuIcon.nativeElement.classList.toggle('extra-margin');
      }
       
      /* For Push
        let toggleIcon=this.toggleMenu.nativeElement;
        toggleIcon.classList.toggle('toggle');
       */
    }
 
previewMenuMode:boolean;
previewPageMode() {
  const substring = "preview";
  //window.location.pathname.includes(substring)
  if (window.location.hostname.includes(substring)) {
    this.previewMenuMode = true;
    this.appPages = this.appPreviewPages;
  }
  else{
    this.previewMenuMode = false; 
    this.storage.set('previewMenuMode',this.previewMenuMode);
    this.appPages = this.appDefaultPages;
  }


    this.storage['previewMenuMode'] = this.previewMenuMode
    //console.log("there2");
    //console.log(this.previewMenuMode);
    //console.log(this.storage['previewMenuMode']);

  }

  PlaceOrderStatus(p) {

    

    if("Nav.PlaceTableOrder" === p.title || "Nav.Stores" === p.title || "Nav.MyOrders" === p.title /* || "Nav.Reservation" === p.title*/) {

      return this.setting.configuration.hidePlaceanOrder;

    } else if("Nav.Offers" === p.title) {
      return this.setting.configuration.hideECouponProgram;
    } else if("Nav.Account" === p.title) {
      return true;
    } else {
      return false;
    }
  }


  getAllBlogs(){
    this.fetchBlogs().subscribe(async blogs => {
      /*
      this.blogs = [];

      this.blogs = blogs;
      
      
      for(var i = 0; i < blogs.length; i++){
        // inject the image URL in each promotions
        this.blogs[i].images['imgURL'] = await this.newsBlogService.fetchImage(blogs[i].images.imgShortName);
        this.blogs[i].images['imgMobileURL'] = await this.newsBlogService.fetchImage(blogs[i].images.imgMobileShortName);
      }
      */

      this.blogsCategories = blogs;

      for(var i = 0; i < this.blogsCategories.length; i++) {
        var category = this.blogsCategories[i];
        category.blogs
      }


    });
  }

  fetchBlogs() {
    if(this.auth.isAuthenticated) {
      this.blogsRequest = {
        merchantId: this.setting.getMerchantId(),
        userId: this.auth.memberId.toString()
      }
    } else {
      this.blogsRequest = {
        merchantId: this.setting.getMerchantId(),
        userId: ""
      }
    }
    
    return this.newsBlogService.getBlogs(this.blogsRequest);
  }

  getAllNews(){
    this.fetchNews().subscribe(async newsCat => {

      this.newsCategories = newsCat;

      for(var i = 0; i < this.newsCategories.length; i++) {
        var category = this.newsCategories[i];
      }
    });
  }

  fetchNews() {
    if(this.auth.isAuthenticated) {
      this.newsRequest = {
        merchantId: this.setting.getMerchantId(),
        userId: this.auth.memberId.toString()
      }
    } else {
      this.newsRequest = {
        merchantId: this.setting.getMerchantId(),
        userId: ""
      }
    }
    

    return this.newsBlogService.getNews(this.newsRequest);
  }
} 